<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      Wyciągi
      <div class="inline float-right" v-if="$page.props.can['add bank statement']">
        <inertia-link class="btn-shtax ml-auto disabled:opacity-50" :href="route('bank_statements.create')">
          <span>Nowy</span>
          <span class="hidden md:inline">wyciąg</span>
        </inertia-link>
      </div>
    </h1>

    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">Numer</th>
          <th class="px-6 pt-6 pb-4">Data dodania</th>
          <th class="px-6 pt-6 pb-4">Dadany przez</th>
          <th class="px-6 pt-6 pb-4">Opis</th>
          <th class="px-6 pt-6 pb-4">Liczba pozycji</th>
          <th class="px-6 pt-6 pb-4">Zaimportowany</th>
          <th class="px-6 pt-6 pb-4">Data importu</th>
          <th class="px-6 pt-6 pb-4" colspan="2">Zaimportowanych pozycji</th>
        </tr>
        <tr v-for="bank_statement in bank_statements.data" :key="bank_statement.id" class="hover:bg-gray-100 focus-within:bg-gray-100" :class="{'bg-orange-50':!bank_statement.is_imported}">
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-shtax-500" :href="route(bank_statement.is_imported && $page.props.can['edit bank statement'] ? 'bank_statements.edit' : 'bank_statements.show', {'bank_statement':bank_statement.id})">
              {{ bank_statement.id }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-shtax-500" :href="route(bank_statement.is_imported && $page.props.can['edit bank statement'] ? 'bank_statements.edit' : 'bank_statements.show', {'bank_statement':bank_statement.id})">
              {{ bank_statement.created_at }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-shtax-500" :href="route(bank_statement.is_imported && $page.props.can['edit bank statement'] ? 'bank_statements.edit' : 'bank_statements.show', {'bank_statement':bank_statement.id})">
              {{ bank_statement.user }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-shtax-500" :href="route(bank_statement.is_imported && $page.props.can['edit bank statement'] ? 'bank_statements.edit' : 'bank_statements.show', {'bank_statement':bank_statement.id})">
              {{ bank_statement.description }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-shtax-500" :href="route(bank_statement.is_imported && $page.props.can['edit bank statement'] ? 'bank_statements.edit' : 'bank_statements.show', {'bank_statement':bank_statement.id})">
              {{ bank_statement.pos_count }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-shtax-500" :href="route(bank_statement.is_imported && $page.props.can['edit bank statement'] ? 'bank_statements.edit' : 'bank_statements.show', {'bank_statement':bank_statement.id})">
              {{ bank_statement.is_imported ? 'Tak' : 'Nie' }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-shtax-500" :href="route(bank_statement.is_imported && $page.props.can['edit bank statement'] ? 'bank_statements.edit' : 'bank_statements.show', {'bank_statement':bank_statement.id})">
              {{ bank_statement.imported_at }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-shtax-500" :href="route(bank_statement.is_imported && $page.props.can['edit bank statement'] ? 'bank_statements.edit' : 'bank_statements.show', {'bank_statement':bank_statement.id})">
              {{ bank_statement.pos_imported }}
            </inertia-link>
          </td>
          <td class="border-t w-px">
            <inertia-link class="px-4 flex items-center" :href="route(bank_statement.is_imported && $page.props.can['edit bank statement'] ? 'bank_statements.edit' : 'bank_statements.show', {'bank_statement':bank_statement.id})" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </inertia-link>
          </td>
        </tr>
        <tr v-if="bank_statements.data.length === 0">
          <td class="border-t px-6 py-4" colspan="8">Nie znaleziono wyciągów.</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="bank_statements.links" />


  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import Icon from '@/Shared/Icon'
import Pagination from '@/Shared/Pagination'

export default {
  metaInfo: { title: 'Wyciągi' },
  components: {
    Pagination,
    Icon
  },
  layout: Layout,
  props: {
    bank_statements: Object,
  },
  data() {
    return {
    }
  },
}
</script>